import { render, staticRenderFns } from "./SvgKonva.vue?vue&type=template&id=831f40f0&"
import script from "./SvgKonva.vue?vue&type=script&lang=js&"
export * from "./SvgKonva.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports